import React, { Component } from "react";
// import DefaultImg from '../../img/01-Splash.jpg';
import { getSkillsLessons } from "../skills/skillAction";
import { connect } from "react-redux";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from "react-router-dom";
import config from "../config/config";
import DefaultImg from './../lessons/lessonImg/default_img_upload.png'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/core";
const override = css`
  display: block;
  margin: 200px auto;
  width: 100px;
  padding: '25%'
`;

class MobileDashBoard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  componentDidMount = async () => {
    window.speechSynthesis.cancel();
    this.setState({ loading: true })
    await this.props.skills().then(res=>{
      this.setState({ loading: false })
    });
  }

  render() {
    const responsive = {
      superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
      }
    };
    console.log("this.props.resultSkill.data", this.props.resultSkillLesson.data);
    const { items } = this.state;
    const { resultSkillLesson } = this.props;
    var dataArray = [];
    const { searchQuery } = this.props;
    if (resultSkillLesson.data) {
      for (let i = 0; i < resultSkillLesson.data.skillResult.length; i++) {
        if(resultSkillLesson.data.skillResult[i].name.toLowerCase().includes(searchQuery.toLowerCase())){
          dataArray.push(
            <div>
              <div className="header">
                <h1 className="nuggets-title">{resultSkillLesson.data.skillResult[i].name}</h1>
              </div>
              <div className="image-div">
                <Carousel responsive={responsive}>
                  {resultSkillLesson.data.lessonResult[i].map((data, index) => (
  
                    <Link
                      to={{
                        pathname: `/lessons/${resultSkillLesson.data.skillResult[i]._id}/${data._id}`,
                       }}
                    >
                      <div className="card" style={{ position: 'relative' }}>
                        {data.isCompleted && (
                          <img
                            alt=""
                            src={require('../../images/check.png')}
                            style={{ position: 'absolute', top: 10, right: 10, height: "20px" }}
                          />
                        )}
                        {data.image ? (
                          <img
                            src={config.api.server_url.request_url.base_url + 'getUploadedFile/' + data.image}
                            alt={data.name}
                            style={{ height: '200px' }}
                          />
                        ) : (
                          <img style={{ height: '200px' }} src={DefaultImg} alt="Img" />
                        )}
                        <p className="price">{data.title}</p>
                      </div>
  
                    </Link>
  
                  ))}
                </Carousel>
              </div>
  
            </div>
          )
        }
      }
    }

    return (
      <>
      {this.state.loading ?
        <SyncLoader
            css={override}
            size={20}
            color={"#0b6eb6"}
            loading={this.state.loading}
        /> :<div className="mobile-dashboard">
        {dataArray}
      </div>}
      </>      
    )
  }
}


const mapDispatchToProps = dispatch => {
  return {
    skills: () => dispatch(getSkillsLessons("skillslessons"))
  };
};

const mapStateToProps = state => {
  return {
    resultSkillLesson: state.skillReducer.resultSkillLesson || [],
    searchQuery: state.headerReducer.searchQuery || "",
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileDashBoard);